import styled from "styled-components";
import { MOBILE_WIDTH, TABLET_WIDTH } from 'datastake-daf/src/constants/Style';

const Style = styled.div`
  font-family: Outfit;
  padding-top: 80px;
  height: 100%;

  &.only-desktop {
    height: 100%;
  }

  .apps-cont {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-width: 100vw;
    overflow-y: auto;
  }

  @media (${TABLET_WIDTH}) {
    padding-top: 72px;
  }

  @media (${MOBILE_WIDTH}) {
    padding-top: 5.12rem;
  }

  .main-cont {
    flex: 1;
    padding-top: 96px;
    padding-bottom: 96px;
    width: 80vw;
    margin-left: auto;
    margin-right: auto;

    &.only-desktop {
      img {
        margin-bottom: 32px;
      }

      p {
        color: #667085;
        font-weight: 300;
        font-size: 20px;
        line-height: 28px;
      }
    }

    .apps-cards {
      display: flex;
      flex-direction: column;
      gap: 64px;

      @media (${MOBILE_WIDTH}) {
        gap: 48px;
      }

      .card {
        padding: 64px 0px 64px 64px;
        background: #F9FAFB;
        border-radius: var(--size-lg);
        display: flex;
        flex-direction: row;
        gap: 48px 100px;

        .tag-c {
          display: flex;
          justify-content: flex-end;

          .tag {
            display: flex;
            gap: 6px;
            padding: 4px 12px;
            background: #EFF8FF;
            border-radius: var(--size);
            color: #175CD3;

            &.private {
              color: #384250;
              background: #E5E7EB;
            }

            &.permissioned {
              color: #996F25;
              background: #FFFBF1;
            }

            span {
              font-size: 14px;
              margin-bottom: 0px;
            }
          }
        }

        .demo {
          padding-top: 10px;

          span {
            font-size: 14px;
            color: #667085;
            margin-bottom 0px;
          }
        }

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;

          @media (${MOBILE_WIDTH}) {
            padding: 0px var(--size-lg)
          }

          .buttons {
            display: flex;
            gap: 12px;

            a {
              flex: 1;
              display: flex;
            }

            @media (${MOBILE_WIDTH}) {
              flex-direction: column;
            }

            .d-btn-cont {
              flex: 1;
            }
          }

          p {
            color: #667085;
            font-weight: 300;
            font-size: 18px;
            line-height: 28px;
            margin-bottom: 40px;

            @media (${MOBILE_WIDTH}) {
              margin-bottom: 32px;
            }
          }

          h1 {
            color: #101828;
            font-weight: 600;
            font-size: 36px;
            line-height: 44px;
            margin-bottom: 20px;

            @media (${MOBILE_WIDTH}) {
              margin-bottom: var(--size);
              font-size: 30px;
              line-height: 38px;
            }
          }


          .img-c {
            margin-bottom: 20px;

            @media (${MOBILE_WIDTH}) {
              margin-bottom: var(--size);
            }
          }

          img {
            width: 109px;

            @media (${MOBILE_WIDTH}) {
              width: 92px;
            }

            &.tazama-logo {
              width: 195px;

              @media (${MOBILE_WIDTH}) {
                width: 180px;
              }
            }
            
            &.tif-logo {
              width: 203px;

              @media (${MOBILE_WIDTH}) {
                width: 183px;
              }
            }
          }
        }

        .right-c {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;

          img {
            width: 100%;
            @media (${MOBILE_WIDTH}) {
              margin-left: auto;
              width: 95%;
              max-width: 500px;
            }
          }
        }

        @media (${MOBILE_WIDTH}) {
          flex-direction: column;
          padding: 40px 0px 0px 0px;
        }

        &.reverse {
          padding: 64px 64px 64px 0px;
          flex-direction: row-reverse;

          .right-c {
            img {
              @media (${MOBILE_WIDTH}) {
                margin-right: auto;
                margin-left: 0;
                width: 95%;
                max-width: 500px;
              }
            }
          }

          @media (${MOBILE_WIDTH}) {
            flex-direction: column;
            padding: var(--size-lg) 0px 0px 0px;

            .right-c {
              div {
                background-position: left bottom;
                margin-left: 0px;
                margin-right: var(--size-lg);
                border-radius: 0px 0px 0px var(--size-lg);
              }
            }
          }
        }
      }
    }

    .apps-header {
      margin-bottom: 64px;

      @media (${MOBILE_WIDTH}) {
        margin-bottom: 48px;
      }

      h2 {
        font-size: 60px;
        font-weight: 600;
        color: #101828;
        margin-bottom: var(--size-lg);

        @media (${MOBILE_WIDTH}) {
          font-size: 40px;
          margin-bottom: 4px;
        }
      }

      p {
        font-size: 22px;
        font-weight: 300;
        color: #667085;

        @media (${MOBILE_WIDTH}) {
          font-size: 20px;
        }
      }
    }

    @media (max-width: 1440px) {
      width: 85vw;
    }

    @media (${TABLET_WIDTH}) {
      width: calc(100vw - 4.6rem);
    }

    @media (${MOBILE_WIDTH}) {
      padding-bottom: 48px;
      padding-top: 48px;
    }
  }
`;

export default Style;
